import React, { useState } from "react";
import {
  Modal, Box, Tabs, Tab, TextField, Button, Avatar, Stack
} from "@mui/material";

export default function UserSettingsModal({ open, onClose, user, onUpdate, onChangePassword }) {
  const [tab, setTab] = useState(0);
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  // const [avatar, setAvatar] = useState(user?.avatar || "");
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");

  // Responsive width: 95vw mobile, 420px PC, max 95vw
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 5,
          p: { xs: 2, sm: 4 },
          width: { xs: "95vw", sm: 420 },
          maxWidth: "95vw",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 16,
        }}
      >
        <Tabs value={tab} onChange={(_, v) => setTab(v)} centered sx={{ mb: 2 }}>
          <Tab label="Thông tin cá nhân" />
          <Tab label="Đổi mật khẩu" />
        </Tabs>
        {tab === 0 && (
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Avatar
              src={user?.avatar || ""}
              sx={{
                width: 64,
                height: 64,
                mx: "auto",
                bgcolor: "#6366f1",
                fontWeight: 700,
                fontSize: 32
              }}
            >
              {user?.name?.[0]?.toUpperCase() || "T"}
            </Avatar>
            <TextField label="Tên" value={name} onChange={e => setName(e.target.value)} fullWidth />
            <TextField label="Số điện thoại" value={phone} onChange={e => setPhone(e.target.value)} fullWidth />
            <Button
              variant="contained"
              size="large"
              sx={{ borderRadius: 99, fontWeight: 700, mt: 1 }}
              onClick={() => onUpdate({ name, phone })}
              fullWidth
            >
              Cập nhật
            </Button>
          </Stack>
        )}
        {tab === 1 && (
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField label="Mật khẩu cũ" type="password" value={oldPass} onChange={e => setOldPass(e.target.value)} fullWidth />
            <TextField label="Mật khẩu mới" type="password" value={newPass} onChange={e => setNewPass(e.target.value)} fullWidth />
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: 99, fontWeight: 700, mt: 1 }}
              onClick={() => onChangePassword(oldPass, newPass)}
              fullWidth
            >
              Đổi mật khẩu
            </Button>
          </Stack>
        )}
      </Box>
    </Modal>
  );
}
